// src/apiBoot.js
const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/+$/, "");
// every hardcoded base you used in code (can list more if needed)
const OLD_BASES = [
  "https://projet-collect-v1-production.up.railway.app".replace(/\/+$/, "")
];

// ---------- fetch patch ----------
const _fetch = window.fetch.bind(window);
window.fetch = (input, init) => {
  let url = typeof input === "string" ? input : input.url;

  // if request starts with an old hardcoded base, swap to API_BASE
  for (const old of OLD_BASES) {
    if (url && url.startsWith(old + "/")) {
      url = API_BASE + url.slice(old.length);
      break;
    }
  }

  if (typeof input === "string") return _fetch(url, init);
  // input is a Request object
  const req = new Request(url, input);
  return _fetch(req, init);
};

// ---------- axios patch (if you use axios anywhere) ----------
try {
  // optional: only if axios is present
  // eslint-disable-next-line no-undef
  if (window.axios) {
    // default base (so /api/... also works)
    window.axios.defaults.baseURL = API_BASE;
    window.axios.defaults.withCredentials = true;

    window.axios.interceptors.request.use((config) => {
      if (!config.url) return config;
      for (const old of OLD_BASES) {
        if (config.url.startsWith(old + "/")) {
          config.url = API_BASE + config.url.slice(old.length);
          break;
        }
      }
      return config;
    });
  }
} catch {}
